import CardView from './messageTemplateButtonsView.html';
import './MessageTemplateButtons.scss';
import { MessageTemplateButtonTypes, CallToActionTypes, HTTP_URL_REGEX, verifyActionsValueLength, } from '../models/MessageTemplateButtons';
const BUTTON_ACTION_LIMIT = 3;
const BUTTON_REPLYS_LIMIT = 3;
const VARIABLE_EXAMPLE = '{{1}}';
class MessageTemplateButtonsController {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
        this.invalidURL = false;
        this.callToActionOptions = [
            {
                label: this.$translate.instant('buttons.callToAction.phoneNumber.option'),
                value: 'phone_number',
            },
            {
                label: this.$translate.instant('buttons.callToAction.linkUrl.option'),
                value: 'url',
            },
        ];
    }
    async $onInit() {
        this.defaultInputText = await this.$translate('buttons.quickReplies.buttonPlaceholder');
        this.urlTootipText = await this.$translate('buttons.callToAction.linkUrl.tip', { variableExample: VARIABLE_EXAMPLE });
        this.ngSortableOptions = {
            animation: 100,
            scroll: true,
            handle: '.anchorButtons',
        };
        this.initOptions();
    }
    initOptions() {
        if (this.buttonType === MessageTemplateButtonTypes.QUICK_REPLY) {
            if (!this.options || this.options.length === 0) {
                this.options = [
                    {
                        type: '',
                        text: this.defaultInputText,
                        inputText: '',
                    },
                ];
            }
            else {
                this.options.map(button => {
                    button.inputText =
                        button.text === this.defaultInputText
                            ? ''
                            : button.text;
                });
            }
        }
        else if (this.buttonType === MessageTemplateButtonTypes.CALL_TO_ACTION) {
            if (!this.options || this.options.length === 0) {
                this.options = [
                    {
                        type: CallToActionTypes.PHONE_NUMBER,
                        text: this.defaultInputText,
                        inputText: '',
                        phone_number: '',
                        url: '',
                    },
                ];
            }
            else {
                this.options.map(button => {
                    button.type = button.type.toLowerCase();
                    button.inputText =
                        button.text === this.defaultInputText
                            ? ''
                            : button.text;
                });
            }
        }
    }
    switchTemplateType(typeName) {
        this.buttonType = typeName;
        this.initOptions();
    }
    canAddNewOption() {
        const urlButtonsCount = this.options.filter(option => option.type === CallToActionTypes.URL).length;
        const phoneNumberButtonsCount = this.options.filter(option => option.type === CallToActionTypes.PHONE_NUMBER).length;
        if (this.buttonType === MessageTemplateButtonTypes.QUICK_REPLY) {
            return this.options.length < BUTTON_REPLYS_LIMIT;
        }
        else if (this.buttonType === MessageTemplateButtonTypes.CALL_TO_ACTION) {
            const totalButtonsCount = this.options.length;
            return totalButtonsCount < BUTTON_ACTION_LIMIT && (urlButtonsCount < 2 || phoneNumberButtonsCount < 1);
        }
    }
    addNewOption() {
        if (this.buttonType === MessageTemplateButtonTypes.QUICK_REPLY) {
            this.options.push({
                type: '',
                text: this.defaultInputText,
                inputText: '',
            });
        }
        else if (this.buttonType === MessageTemplateButtonTypes.CALL_TO_ACTION) {
            this.options.push({
                type: this.options[0].type === CallToActionTypes.PHONE_NUMBER
                    ? CallToActionTypes.URL
                    : CallToActionTypes.PHONE_NUMBER,
                text: this.defaultInputText,
                inputText: '',
                phone_number: '',
                url: '',
            });
        }
    }
    hideAnchor() {
        return this.options.length < 2 || this.thereTranslations();
    }
    removeOption(items, removedItem) {
        this.options = items;
        if (items.length === 0) {
            this.buttonType = MessageTemplateButtonTypes.DEFAULT;
        }
    }
    checkIfOptionIsEmpty(index) {
        if (!this.options[index].type) {
            this.options[index].type = CallToActionTypes.PHONE_NUMBER;
        }
    }
    verifyItemLength(item, isUrl = false) {
        return verifyActionsValueLength(item, isUrl);
    }
    verifyUniqueButtonName(item) {
        let counterEqual = 0;
        this.options.map(option => {
            if (option.text === item) {
                counterEqual++;
            }
        });
        return counterEqual > 1;
    }
    verifyURLValidFormat(item) {
        if (item === '') {
            this.invalidURL = false;
        }
        else {
            const result = new RegExp(HTTP_URL_REGEX);
            this.invalidURL = !result.test(item);
        }
    }
    hasEmptyInput() {
        let hasEmpty = 0;
        this.options.map(option => {
            if (!option.inputText) {
                hasEmpty++;
            }
        });
        return hasEmpty > 0;
    }
    changeChipValue($index) {
        this.options[$index].text = this.options[$index].inputText;
    }
}
MessageTemplateButtonsController.$inject = ['$translate'];
export const MessageTemplateButtonsComponent = {
    template: CardView,
    controller: MessageTemplateButtonsController,
    controllerAs: '$ctrl',
    bindings: {
        buttonType: '=?',
        options: '=?',
        thereTranslations: '&?',
    },
};
